import { Box } from '@chakra-ui/react';
import VFormFieldHorizontal from '@voly/ui-components/src/v2/VFormFieldHorizontal';
import VTooltip from '@voly/ui-components/src/v2/VTooltip';
import VTreeSelect from '@voly/ui-components/src/v2/VTreeSelect/VTreeSelect';
import { ReactElement } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import { TCustomField } from 'src/app/project/modules/custom-fields/custom-fields.model';
import PointFieldName from './PointFieldName';
import { toTreeItems } from '../../../utils/customFieldTreeItems';
import FieldLockedIcon from '../FieldLockedIcon';

const NOTHING_SELECTED = '';

interface PointFieldListProps {
  field: TCustomField;
  value: string;
  readOnly: boolean;
  onSave: (value: string) => void;
}

const PointFieldList = ({ field, value, readOnly, onSave }: PointFieldListProps): ReactElement => {
  const commit = (ids: string[]): void => onSave(ids[0] ?? NOTHING_SELECTED);

  return (
    <VFormFieldHorizontal
      data-testid="point-custom-field-row"
      size="sm"
      label={<PointFieldName field={field} />}
      helperText={field.description}
      errorText={undefined}
      invalid={undefined}
      readOnly={readOnly}
      disabled={field.lockedValue}
    >
      <VTooltip width="100%" content={translate('locked_by_admin')} disabled={!field.lockedValue}>
        <Box
          data-testid="point-custom-field-control"
          display="grid"
          gridTemplateColumns="minmax(0, 1fr)"
        >
          <VTreeSelect
            items={toTreeItems(field.subList ?? [])}
            value={value === NOTHING_SELECTED ? [] : [value]}
            onCommit={commit}
            placeholder={translate('select...')}
            disabled={readOnly || field.lockedValue}
            startElement={field.lockedValue ? <FieldLockedIcon /> : undefined}
          />
        </Box>
      </VTooltip>
    </VFormFieldHorizontal>
  );
};

export default PointFieldList;
